import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';

/**
 * PostHog capture function with live-topics domain prefix.
 * All events are sent as `live-topics:eventName` (e.g. live-topics:panel_opened).
 */
export function usePostHogCaptureLiveTopics() {
  return usePostHogCapture({ domain: 'live-topics' });
}
